import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const when = (iso) => (iso ? new Date(iso).toLocaleString() : "—");

// ID-076: unfinished import drafts offered when the import window opens
export const DraftPicker = ({ drafts, onResume, onStartNew }) => (
  <div className="mt-4 space-y-3 rounded-md border border-border bg-alabaster p-4" data-testid="import-drafts">
    <p className="text-xs font-semibold uppercase tracking-wider text-charcoal">Unfinished imports ({drafts.length})</p>
    <ul className="space-y-2">
      {drafts.map((d) => (
        <li key={d.preview_id} className="flex flex-wrap items-center gap-2 rounded-md border border-border bg-white p-3 text-xs" data-testid={`import-draft-${d.preview_id}`}>
          <span className="font-medium text-charcoal">{d.filename}</span>
          {d.supplier_reference && <span>Ref {d.supplier_reference}</span>}
          {d.po_number && <span>{d.po_number}</span>}
          {d.containers?.length > 0 && <span>Container {d.containers.join(", ")}</span>}
          <span className="text-warmgrey">{d.resolved_rows} of {d.unresolved_rows} lines resolved or excluded · saved {when(d.saved_at)}</span>
          <Button size="sm" className="ml-auto h-8 bg-charcoal px-3 text-xs text-white" onClick={() => onResume(d.preview_id)} data-testid={`import-draft-resume-${d.preview_id}`}>Resume draft</Button>
        </li>
      ))}
    </ul>
    <Button size="sm" variant="outline" className="h-8 text-xs" onClick={onStartNew} data-testid="import-draft-start-new">Start new import</Button>
    <p className="text-xs text-warmgrey">Starting a new import keeps these drafts; each upload is saved as its own draft.</p>
  </div>
);

export const LeaveConfirm = ({ open, onContinue, onSaveExit, onDiscard, busy }) => (
  <Dialog open={open} onOpenChange={(o) => !o && onContinue()}>
    <DialogContent className="border-border bg-white sm:max-w-md" data-testid="import-leave-dialog">
      <DialogHeader>
        <DialogTitle className="font-display text-2xl font-light text-charcoal">You have unsaved changes</DialogTitle>
        <DialogDescription>Leaving now may discard your current work.</DialogDescription>
      </DialogHeader>
      <div className="flex flex-wrap gap-2">
        <Button variant="outline" onClick={onContinue} data-testid="import-leave-continue">Continue Editing</Button>
        <Button className="bg-charcoal text-white" disabled={busy} onClick={onSaveExit} data-testid="import-leave-save">Save Draft &amp; Exit</Button>
        <Button className="bg-status-sold text-white hover:opacity-90" disabled={busy} onClick={onDiscard} data-testid="import-leave-discard">Discard Changes</Button>
      </div>
    </DialogContent>
  </Dialog>
);
